import React from 'react';
import { Link } from "react-router-dom";
import reviews from "./data/reviews.json"; 
import verified from "./data/verified.json";

const Reviews = () => {

    document.title = "Veta - Reviews";

    const reviewsLength = reviews.length;
    return (
        <div className="reviews-container">
            <h1>All Reviews ({reviewsLength})</h1>
            <p>
                Veta is being rated on Images & Photos Optimization, 
                Images & Photo Quality, Accessibility of hiring one 
                of the pictures taker (creator).
            </p>

            <div className="reviews-list">                
                {
                    reviews ? reviews.map((review) =>
                        review.user == verified.map((verifiedReview) => verifiedReview.verified_review) ?
                            <div className="review-card" key={review.id}>
                                <h3 title="Twitter">
                                    <a href="https://twitter.com/hafidaanouche" target="_blank">
                                        <u>{review.user}</u>
                                        <svg height="20px" width="20px" title="Verified" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-primary" viewBox="0 0 20 20" fill="#1da1f2">
                                            <path fill-rule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd">
                                            </path>
                                        </svg>
                                    </a>
                                </h3>
                                <span className="user-role">{review.user_role}</span>
                                <p>{review.content}</p>
                                <span className="rating">{review.rating}</span>
                                <span className="user-rating">{review.user_rating}</span>
                            </div>
                        :
                            <div className="review-card" key={review.id}>
                                <h3 title="Twitter">
                                    <a href="https://twitter.com/hafidaanouche" target="_blank">
                                        <u>{review.user}</u>
                                    </a>
                                </h3>
                                <span className="user-role">{review.user_role}</span>
                                <p>{review.content}</p>
                                <span className="rating">{review.rating}</span>
                                <span className="user-rating">{review.user_rating}</span>
                            </div>
                    ) : "No reviews yet."
                }

                <div className="write-review" title="Write a review">
                    <h4>Submit your review about us.</h4>
                    <Link to="/write-review">
                        Write a review
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="white" height="18px" width="18px">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
                            </path>
                        </svg>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default Reviews;